module.exports = __webpack_public_path__ + "img/taptab-endpoints.1de60982.jpg";